import { createTheme } from '@mui/material/styles';

// Admin theme — ShareGiver brand palette
// Navy #173B67 | Blue #3478C8 | Teal #43A6A1 | Pale #EAF3FA | Accent #DC6B4E | Text #17212B
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#3478C8',
      light: '#5B94D6',
      dark: '#173B67',
    },
    secondary: {
      main: '#DC6B4E',
      light: '#E58A72',
      dark: '#B84A2E',
    },
    background: {
      default: '#F7FAFC',
      paper: '#ffffff',
    },
    text: {
      primary: '#17212B',
      secondary: '#4A5560',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#173B67',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(23, 33, 43, 0.1)',
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 6,
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#6B9FD9',
      light: '#93BBE6',
      dark: '#3478C8',
    },
    secondary: {
      main: '#E58A72',
      light: '#F0A894',
      dark: '#DC6B4E',
    },
    background: {
      default: '#17212B',
      paper: '#1E2A38',
    },
    text: {
      primary: '#EAF3FA',
      secondary: '#B7C5D3',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E2A38',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 6,
        },
      },
    },
  },
});

// Default export for backward compatibility
export const theme = lightTheme;
